// import ImageSelect from './ImageSelect'
const ImageSelect = r => require.ensure([], () => r(require('./ImageSelect.vue')), 'imageselect-components-chunk')

export default ImageSelect
